import classes from "./GameBlogPost.module.css"
import Card from "../ui/Card.js"
function GameBlogPost(props)
{
    return (
            <li className={classes.licontainer}>
                <div className={classes.container}>
                    {props.update != null ? (
                    <div id = "has-photo" className = {classes.post}>
                            <div className={classes.content}>
                                <ul className = {classes.updateul}>
                                    <p className = {`${classes.updatecontent} ${classes.updatedate}`}>   {props.date}</p>
                                    <p className = {classes.updatecontent}>{props.update.update1}</p>
                                    <p className = {classes.updatecontent}>{props.update.update2}</p>
                                    <p className = {classes.updatecontent}>{props.update.update3}</p>
                                    <p className = {classes.updatecontent}>{props.update.update4}</p>
                                </ul>
                                {/* <p>{props.update1}</p> */}
                            </div>
                        <iframe className={classes.card}title={ props.id}src={ props.image}>
                        </iframe>
                    </div>
                    ):(
                        <div id = "no-photo"></div>)
                    }
                        
                    
                </div>
            </li>
        );
}

//  {
//                             props.update.map(update => (
//                                 <li>
//                                     {update}
//                             </li>
//                         ))}

export default GameBlogPost;